module.exports = __webpack_public_path__ + "static/media/version_release.c03eed16.svg";